import React, { ReactChild, ReactElement, ReactNode, useMemo } from 'react'
import { Wrapper } from 'lib/noop-wrapper'
import classNames from 'classnames'
import style from './module-title.module.scss'

interface IProps {
  rightContent?: ReactNode
  prefix?: ReactChild
  titleColor?: string
  className?: string
}

const ModuleTitle: React.FC<IProps> = ({
  rightContent,
  prefix,
  titleColor,
  children,
  className,
}) => {
  const wrapper = useMemo<Wrapper>(() => {
    if (!rightContent) {
      return (content) => (
        <h2
          className={`${style['module-title']} module-title line-1 ${
            className || ''
          }`}
        >
          {content}
          <style jsx>
            {`
              .module-title {
                color: ${titleColor ? titleColor : '#1f2129'};
              }
            `}
          </style>
        </h2>
      )
    }
    return (content) => (
      <React.Fragment>
        <div className={classNames(style['title-wrapper'], className)}>
          <h2
            className={`${style['module-title']} module-title line-1 tw-flex-1 tw-mr-6`}
          >
            {prefix}
            {content}
          </h2>
          <div className="title-right tw-flex-none">{rightContent}</div>
        </div>
        <style jsx>
          {`
            .module-title {
              color: ${titleColor ? titleColor : '#1f2129'};
            }
          `}
        </style>
      </React.Fragment>
    )
  }, [rightContent])

  return wrapper(children) as ReactElement
}

export default ModuleTitle
